import { observer } from 'mobx-react'
import React, { Component } from 'react'
import ShadowBoxItem from '../../common/ShadowBoxItem'
import style from './style.module.less'

@observer
export default class extends Component {
  render() {
    const {
      setMeal,
      activation,
      motivation,
      discard,
      propertyId
    } = this.props.store
    return (
      <div className={style.group}>
        {setMeal.map((el, i) => (
          <ShadowBoxItem
            key={i}
            index={i}
            isCase={propertyId}
            maxLength={setMeal.length}
            showPath={el.data.cover_path}
            {...el}
            {...this.props}
            onClick={() => activation(i)}
            onMoveUp={() => motivation('up', i)}
            onMoveDown={() => motivation('down', i)}
            onDelete={() => discard(i)}
            // onReplace={() => replace(el, i)}
          />
        ))}
      </div>
    )
  }
}
